import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { DoctorTypeConstants } from "../types/DoctorTypeConstants";
import { history } from "../../components/helpers/History";
import { DoctorAction } from "../actions/DoctorAction";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";

function* register(action) {
  try {
    var user = action.data;
    var payload = {
      hospitalId: user.hospitalName,
      firstName: user.firstName,
      lastName: user.lastName,
      userName: user.email,
      docSpecialtyList: user.specialist,
      telePhoneNo: user.phoneNo,
      email: user.email,
      status: user.status,
      password: user.password,
    };
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/doctor/save", payload);
    if (response.status === "SUCCESS") {
      yield put(DoctorAction.registrationSuccess(response.result));
    } else {
      yield put(DoctorAction.registrationFailiure(response.result.description));
    }
  } catch (e) {
    yield put(DoctorAction.registrationFailiure(e));
  }
}

function* updateProfile(action) {
  try {
    var user = action.data;
    var payload = {
      id: user.id,
      hospitalId: user.hospitalId,
      firstName: user.firstName,
      lastName: user.lastName,
      docSpecialtyList: user.specialist,
      telePhoneNo: user.phoneNo,
      email: user.email,
      status: user.status,
    };
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/doctor/update", payload);
    if (response.status === "SUCCESS") {
      yield put(DoctorAction.updateProfileSuccess(response.result));
    } else {
      yield put(
        DoctorAction.updateProfileFailiure(response.result.description)
      );
    }
  } catch (e) {
    yield put(DoctorAction.updateProfileFailiure(e));
  }
}
function* updateProfileSuccess(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.success("Updated successfully."));
    history.goBack();
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* updateProfileFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}
function* registrationSuccess(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.success("Registered successfully."));
    history.goBack();
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* registrationFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getAllDoctors(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/doctor");
    if (response.status === "SUCCESS") {
      yield put(DoctorAction.getAllDoctorSuccess(response.result));
    } else {
      yield put(DoctorAction.getAllDoctorFailiure(response.result.description));
    }
  } catch (e) {
    yield put(DoctorAction.getAllDoctorFailiure(e));
  }
}

function* getAllDoctorSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getAllDoctorFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getDoctorById(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/doctor/" + action.id);
    if (response.status === "SUCCESS") {
      yield put(DoctorAction.getDoctorByIdSuccess(response.result));
    } else {
      yield put(
        DoctorAction.getDoctorByIdFailiure(response.result.description)
      );
    }
  } catch (e) {
    yield put(DoctorAction.getDoctorByIdFailiure(e));
  }
}

function* getDoctorByIdSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getDoctorByIdFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchDoctor(action) {
  try {
    var payload = {
      startDateTime: action.data.startDateTime,
      endDateTime: "",
    };
    yield put(BackDropActions.start());
    const response = yield call(
      HttpService.post,
      "/appointment/search/doctor",
      payload
    );
    if (response.status === "SUCCESS") {
      yield put(DoctorAction.searchDoctorSuccess(response.result));
    } else {
      yield put(DoctorAction.searchDoctorFailiure(response.result.description));
    }
  } catch (e) {
    yield put(DoctorAction.searchDoctorFailiure(e));
  }
}

function* searchDoctorSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchDoctorFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchDoctorBySpecialization(action) {
  try {
    yield put(BackDropActions.start());
    const data = yield call(HttpService.get, "/search/doctor");
    yield put(DoctorAction.searchDoctorBySpecializationSuccess(data));
  } catch (e) {
    yield put(DoctorAction.searchDoctorBySpecializationFailiure(e));
  }
}

function* searchDoctorBySpecializationSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchDoctorBySpecializationFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchDoctorAppointment(action) {
  try {
    yield put(BackDropActions.start());
    const data = yield call(HttpService.get, "/appointments");
    yield put(DoctorAction.getDoctorByIdSuccess(data));
  } catch (e) {
    yield put(DoctorAction.getDoctorByIdFailiure(e));
  }
}

function* searchDoctorAppointmentSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchDoctorAppointmentFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}
function* docotorSaga() {
  yield takeEvery(DoctorTypeConstants.REGISTER_DOCTOR_REQUEST, register);
  yield takeEvery(
    DoctorTypeConstants.REGISTER_DOCTOR_FAILURE,
    registrationFailiure
  );
  yield takeEvery(
    DoctorTypeConstants.REGISTER_DOCTOR_SUCCESS,
    registrationSuccess
  );
  yield takeEvery(DoctorTypeConstants.UPDATE_DOCTOR_REQUEST, updateProfile);
  yield takeEvery(
    DoctorTypeConstants.UPDATE_DOCTOR_SUCCESS,
    updateProfileSuccess
  );
  yield takeEvery(
    DoctorTypeConstants.UPDATE_DOCTOR_FAILURE,
    updateProfileFailiure
  );
  yield takeEvery(DoctorTypeConstants.GET_ALL_DOCTOR_REQUEST, getAllDoctors);
  yield takeEvery(
    DoctorTypeConstants.GET_ALL_DOCTOR_SUCCESS,
    getAllDoctorSuccess
  );
  yield takeEvery(
    DoctorTypeConstants.GET_ALL_DOCTOR_FAILIURE,
    getAllDoctorFailiure
  );
  yield takeEvery(DoctorTypeConstants.GET_DOCTOR_BY_ID_REQUEST, getDoctorById);
  yield takeEvery(
    DoctorTypeConstants.GET_DOCTOR_BY_ID_SUCCESS,
    getDoctorByIdSuccess
  );
  yield takeEvery(
    DoctorTypeConstants.GET_DOCTOR_BY_ID_FAILIURE,
    getDoctorByIdFailiure
  );
  yield takeEvery(DoctorTypeConstants.SEARCH_DOCTOR_REQUEST, searchDoctor);
  yield takeEvery(
    DoctorTypeConstants.SEARCH_DOCTOR_SUCCESS,
    searchDoctorSuccess
  );
  yield takeEvery(
    DoctorTypeConstants.SEARCH_DOCTOR_FAILIURE,
    searchDoctorFailiure
  );
  yield takeEvery(
    DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_REQUEST,
    searchDoctorBySpecialization
  );
  yield takeEvery(
    DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_SUCCESS,
    searchDoctorBySpecializationSuccess
  );
  yield takeEvery(
    DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_FAILIURE,
    searchDoctorBySpecializationFailiure
  );
  yield takeEvery(
    DoctorTypeConstants.SEARCH_DOCTOR_FAILIURE,
    searchDoctorAppointment
  );
  yield takeEvery(DoctorTypeConstants.DOCTOR_APPOINTMENT_REQUEST, searchDoctor);
  yield takeEvery(
    DoctorTypeConstants.DOCTOR_APPOINTMENT_SUCCESS,
    searchDoctorAppointmentSuccess
  );
  yield takeEvery(
    DoctorTypeConstants.DOCTOR_APPOINTMENT_FAILIURE,
    searchDoctorAppointmentFailiure
  );
}

export default docotorSaga;
